import { Users, Tag, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import InvitationManager from '../components/InvitationManager';
import EntryTypesManager from '../components/EntryTypesManager';
import LanguageSettings from '../components/LanguageSettings';
import { useState } from 'react';

type TabType = 'invitations' | 'entry-types' | 'language';

export default function Admin() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<TabType>('invitations');

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-800">{t('admin.title')}</h1>
        <p className="text-slate-600 mt-1">{t('admin.subtitle')}</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200">
        <div className="border-b border-slate-200">
          <div className="grid grid-cols-3 sm:flex">
            <button
              onClick={() => setActiveTab('invitations')}
              className={`flex items-center justify-center sm:justify-start gap-2 px-3 sm:px-6 py-4 font-medium transition-colors border-b-2 ${
                activeTab === 'invitations'
                  ? 'border-emerald-600 text-emerald-600'
                  : 'border-transparent text-slate-600 hover:text-slate-800'
              }`}
            >
              <Users className="w-5 h-5" />
              <span className="hidden sm:inline">{t('admin.invitations')}</span>
            </button>
            <button
              onClick={() => setActiveTab('entry-types')}
              className={`flex items-center justify-center sm:justify-start gap-2 px-3 sm:px-6 py-4 font-medium transition-colors border-b-2 ${
                activeTab === 'entry-types'
                  ? 'border-emerald-600 text-emerald-600'
                  : 'border-transparent text-slate-600 hover:text-slate-800'
              }`}
            >
              <Tag className="w-5 h-5" />
              <span className="hidden sm:inline">{t('admin.entryTypes')}</span>
            </button>
            <button
              onClick={() => setActiveTab('language')}
              className={`flex items-center justify-center sm:justify-start gap-2 px-3 sm:px-6 py-4 font-medium transition-colors border-b-2 ${
                activeTab === 'language'
                  ? 'border-emerald-600 text-emerald-600'
                  : 'border-transparent text-slate-600 hover:text-slate-800'
              }`}
            >
              <Globe className="w-5 h-5" />
              <span className="hidden sm:inline">{t('admin.languageSettings')}</span>
            </button>
          </div>
        </div>

        <div className="p-4 sm:p-6">
          {activeTab === 'invitations' && <InvitationManager />}
          {activeTab === 'entry-types' && <EntryTypesManager />}
          {activeTab === 'language' && <LanguageSettings />}
        </div>
      </div>
    </div>
  );
}
